var Backbone = require('backbone');


var SessionModel = Backbone.Model.extend({
    url: '/api/login/session'
});


module.exports = SessionModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/session-model.js
// module id = 187
// module chunks = 0